import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { avatarAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(avatarAnatomy.keys);

const baseSize = definePartsStyle({
  container: {
    width: 10,
    height: 10,
    fontSize: 'xl'
  }
});

// export the base styles in the component theme
export const avatarTheme: ComponentStyleConfig = defineMultiStyleConfig({
  sizes: {
    base: baseSize
  }
});
